module.exports = __webpack_public_path__ + "img/on-filled.d1586888.svg";